module.exports = __webpack_public_path__ + "assets/448c262e8911337cbb331809cd693cdd.png";